// ============================================================================
// DeadlineRow — one development in the Deadlines panel (DeadlinePanel.js).
//
// Lifted verbatim out of DeadlinePanel (AUD-06) so the overdue groups and the
// "Stuck — needs review" list render the SAME row: same markup, same classes
// from DeadlinePanel.module.css, same Postpone popover. The popover's open
// state stays in the panel (one popover at a time across every list); this
// component only renders it.
// ============================================================================

import React from 'react';
import styles from './DeadlinePanel.module.css';

export const POSTPONE_OPTIONS = [1, 3, 7, 14];

export default function DeadlineRow({ dev, daysOver, open, pending, onToggle, onPick }) {
  const data = dev?.data || {};
  const devNumber = dev.dev_number || data.dev_number || '—';
  const designer  = dev.designer || data.designer || '—';
  const status    = dev.full_status || data.full_status || '—';
  // Simplified model: every row is overdue. Full red bar, no
  // percentage, no "days left", no "X of Y" denominator.
  const headlineCopy = daysOver < 1
    ? 'Overdue'
    : `${daysOver} day${daysOver === 1 ? '' : 's'} over`;

  return (
    <div className={`${styles.row} ${styles.overdue}`}>
      <div className={styles.rowContent}>
        <div className={styles.rowId}>
          <span className={styles.rowDn}>{devNumber}</span>
          <span className={styles.rowDes}>{designer}</span>
        </div>
        <div className={styles.rowStatus}>{status}</div>
        <div className={styles.rowProg}>
          <div className={styles.bar}>
            <i style={{ width: '100%' }}/>
          </div>
          <span>
            <b>{headlineCopy}</b>
          </span>
        </div>
      </div>
      <button
        type="button"
        className={styles.rowAct}
        onClick={onToggle}
        disabled={pending}
      >
        Postpone
      </button>
      {open && (
        <div className={styles.pop} role="dialog" aria-label="Postpone options">
          <div className={styles.popTtl}>Remind me in</div>
          <div className={styles.popOpts}>
            {POSTPONE_OPTIONS.map((days) => (
              <button
                key={days}
                type="button"
                className={styles.popOpt}
                onClick={() => onPick(days)}
                disabled={pending}
              >
                +{days} {days === 1 ? 'day' : 'days'}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
